var $b8a0a0051cce96cd$exports = {};
$b8a0a0051cce96cd$exports = {
    "loading": `Cargando\u{2026}`,
    "loadingMore": `Cargando m\xe1s\u{2026}`
};


export {$b8a0a0051cce96cd$exports as default};
//# sourceMappingURL=es-ES.mjs.map
